import { hotjar } from 'react-hotjar';
import { combineEpics } from 'redux-observable';
import { filter, ignoreElements, map } from 'rxjs/operators';
import { isActionOf } from 'typesafe-actions';

import { getHotjarSiteId } from '../ducks/config';
import { initHotjar } from '../ducks/track';
import { isDefined } from '../utils/is';

const initHotjarEpic: AppEpic = (action$, state$) =>
  action$.pipe(
    filter(isActionOf(initHotjar)),
    map(_ => getHotjarSiteId(state$.value)),
    filter(isDefined),
    map(siteId => hotjar.initialize(siteId)),
    ignoreElements(),
  );

export const trackEpic = combineEpics(initHotjarEpic);
